import { render } from "./RequisitionChart.vue?vue&type=template&id=4e348e7c&ts=true"
import script from "./RequisitionChart.vue?vue&type=script&lang=ts"
export * from "./RequisitionChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__